// extracted by mini-css-extract-plugin
export var mcpLimitAuditLogClearButton = "mcp-limit-audit-log__clear-button_OJjArCrVEQ6zxfXNMs4o";
export var mcpLimitAuditLogLoadingContainer = "mcp-limit-audit-log__loading-container_P8_zX9b1i74wKoADXFYg";
export var mcpLimitAuditLogPagination = "mcp-limit-audit-log__pagination_y9PuJZ2y6nmVPz4jKE9i";
export var mcpLimitAuditLogSectionTitle = "mcp-limit-audit-log__section-title_Fqe5xh9GKaXh8E_KzAs8";
export var mcpLimitAuditLogSeparator = "mcp-limit-audit-log__separator_zJwiiT0DRmn6G5wBhFaf";
export var mcpLimitAuditLogTotalCount = "mcp-limit-audit-log__total-count_W5jW0KnuU3gXKlHO6cKw";